import home from './home'
import dataSec from './data'
import servicesSec from './services'
import ecoSec from './eco'
import infrastructureSec from './infrastructure'
import usecasesSec from './usecases'
import securitySec from './security'
import sustainabilitySec from './sustainability'
import whyDellSec from './why-dell'

export const data = {
  pages: [
    ...home,
    ...dataSec,
    ...servicesSec,
    ...ecoSec,
    ...infrastructureSec,
    ...usecasesSec,
    ...securitySec,
    ...sustainabilitySec,
    ...whyDellSec, 
  ]
}